import React from "react";
import {
  Card,
  FormGroup,
  Label,
  Input,
  Col,
  Button,
  CardBody,
  Row,
} from "reactstrap";
import { Colxx } from "components/common/CustomBootstrap";

const Correction = (props) => {
  const { questions, setQuestions } = props;

  const handleCorrectionDetails = (e, index) => {
    let newQuestions = [...questions];
    newQuestions[index][e.target.name] = e.target.value;
    setQuestions(newQuestions);
  };
  const handleCorrectionAddNextOption = (e, index) => {
    let newQuestions = [...questions];
    newQuestions[index].answers.push([""]);
    setQuestions(newQuestions);
  };

  const handleRemoveOption = (e, index, inputIndex) => {
    let newQuestions = [...questions];
    newQuestions[index].answers.splice(inputIndex, 1);
    setQuestions(newQuestions);
  };

  const handleCorrectionAddOption = (e, index, answerIndex) => {
    let newQuestions = [...questions];
    newQuestions[index]?.answers[answerIndex]?.push("");
    setQuestions(newQuestions);
  };

  const handleCorrectionChangeOption = (e, index, innerIndex, answerIndex) => {
    let newQuestions = [...questions];
    newQuestions[index].answers[innerIndex][answerIndex] = e.target.value;
    setQuestions(newQuestions);
  };

  const handleCorrectionAddQuestion = () => {
    setQuestions([...questions, { prompt: "", answers: [[""]] }]);
  };

  const handleCorrectionRemoveQuestion = (e, index) => {
    let newQuestions = [...questions];
    newQuestions.splice(index, 1);
    setQuestions(newQuestions);
  };

  return (
    <>
      <Colxx xxs="12" className="mb-4">
        {questions.map((question, index) => (
          <Card className="p-4 m-4" key={index}>
            <div className="position-absolute card-top-buttons">
              <span
                className="btn btn-header-light icon-button"
                style={{ cursor: "pointer" }}
                onClick={(e) => handleCorrectionRemoveQuestion(e, index)}
              >
                <i className="simple-icon-trash" />
              </span>
            </div>
            <CardBody>
              <FormGroup row>
                <Label sm="3">Question {index + 1}</Label>
                <Colxx sm="9" className="text-left">
                  <Input
                    type="text"
                    name="prompt"
                    value={question.prompt}
                    onChange={(e) => handleCorrectionDetails(e, index)}
                  />
                </Colxx>
              </FormGroup>
              <FormGroup row>
                <Label sm="3">
                  Answers
                  <span
                    className="btn btn-header-light icon-button ml-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleCorrectionAddNextOption(e, index)}
                  >
                    <i className="simple-icon-plus" />
                  </span>
                </Label>
                <Colxx sm="9" row>
                  {question.answers.map((options, innerIndex) => (
                    <Row key={innerIndex} className="text-left flex">
                      <span
                        className="btn btn-header-light icon-button mt-2"
                        style={{ cursor: "pointer" }}
                        onClick={(e) =>
                          handleRemoveOption(e, index, innerIndex)
                        }
                      >
                        <i className="simple-icon-minus" />
                      </span>
                      <span className="mt-3">{innerIndex + 1}</span>
                      {options.map((key, answerIndex) => (
                        <Col md="4" className="my-2" key={answerIndex}>
                          <Input
                            type="text"
                            value={key}
                            onChange={(e) =>
                              handleCorrectionChangeOption(
                                e,
                                index,
                                innerIndex,
                                answerIndex
                              )
                            }
                          />
                        </Col>
                      ))}
                      <Col md="1">
                        <Button
                          onClick={(e) =>
                            handleCorrectionAddOption(e, index, innerIndex)
                          }
                        >
                          +
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Colxx>
              </FormGroup>
            </CardBody>
          </Card>
        ))}

        <Button className="mt-3" onClick={handleCorrectionAddQuestion}>
          Add Question
        </Button>
      </Colxx>
    </>
  );
};

export default Correction;
